import { render, staticRenderFns } from "./ParticipantField.vue?vue&type=template&id=645b4f70"
import script from "./ParticipantField.vue?vue&type=script&lang=js"
export * from "./ParticipantField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports